define('lq/events/actions/logoffCommand',[
    'lq',
    'lq/events/actions/eventAction'
], function (lq, EventAction) {
    'use strict';

    function LogoffCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(LogoffCommand, EventAction);

    LogoffCommand.typeName = 'LogoffCommand';

    LogoffCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    LogoffCommand.prototype.execute = function (continuation) {
        var self = this;
        this.piping.dispatcher.dispatch('LicquidAction/LogOff')
            .done(function (result) {
                if (result && result.isFederated) {
                    window.location = lq.getTenantUrl('FederatedLogin/Logout');
                }
                else if (self.eventIsEnabled('userLoggedOff'))
                    self.refreshCsrfTokenForNewUser(function () {
                        self.triggerEvent('userLoggedOff', continuation, { parentCommand: "LogoffCommand" });
                    });
                else
                    window.location = lq.getTenantUrl('');
            });
    };

    return LogoffCommand;
});
